import React from 'react';

import { ActualOperation } from '../../types/interfaces';

const UnitMeasurementTemplate = (job: ActualOperation | undefined) => {
  // Fallback label for jobs without a valid measure
  const fallbackLabel = '';

  if (!job) {
    console.warn('Job data is undefined.');
    return <div>{fallbackLabel}</div>;
  }

  if (!job.measure || !job.measure.label) {
    console.warn('Measure data is missing or invalid:', job.measure);
    return <div>{fallbackLabel}</div>;
  }

  return <div>{job.measure.label}</div>;
};

export default UnitMeasurementTemplate;
